<template>
  <div>
    <UploadErrorAlert
      v-if="alreadyPresent.length > 0"
      :files="alreadyPresent"
      color="warning"
      icon="cipAlertTriangle"
      :message="getErrorMessage($pgettext('globalUploader.errors', '%{numFiles} files already present'))"
    />
    <UploadErrorAlert
      v-if="invalidFile.length > 0"
      :files="invalidFile"
      color="danger"
      icon="cipXCircle"
      :message="getErrorMessage($pgettext('globalUploader.errors', '%{numFiles} invalid files'))"
    />
    <UploadErrorAlert
      v-if="uploadLimit.length > 0"
      :files="uploadLimit"
      color="warning"
      icon="cipAlertTriangle"
      :message="getErrorMessage($pgettext('globalUploader.errors', '%{numFiles} files will not be uploaded'))"
    />
    <UploadErrorAlert
      v-if="userCancelled.length > 0"
      :files="userCancelled"
      color="info"
      icon="cipInfo"
      :message="getErrorMessage($pgettext('globalUploader.errors', '%{numFiles} files stopped by the user'))"
    />
    <UploadErrorAlert
      v-if="uploadProblem.length > 0"
      :files="uploadProblem"
      color="danger"
      icon="cipXCircle"
      :message="getUploadProblemMessage()"
    />
  </div>
</template>

<script>
import uploadErrors from "@/domain/core/constant/uploadErrors";
import UploadErrorAlert from "@/domain/uploader/components/UploadErrorAlert.vue";


export default {
  name: 'UploadErrors',
  components: {UploadErrorAlert},
  props: {
    files: {
      type: Array,
      required: true
    }
  },
  computed: {
    alreadyPresent() {
      return this.files.filter(file => file.error === uploadErrors.alreadyPresent)
    },
    invalidFile() {
      return this.files.filter(file => file.error === uploadErrors.invalidFile)
    },
    uploadLimit() {
      return this.files.filter(file => file.error === uploadErrors.uploadLimit)
    },
    userCancelled() {
      return this.files.filter(file => file.error === uploadErrors.userCancelled)
    },
    uploadProblem() {
      return this.files.filter(file => file.error === uploadErrors.uploadProblem)
    },
    uploadErrors() {
      return uploadErrors
    }
  },
  methods: {
    getErrorMessage(message) {
      return this.$gettextInterpolate(
         message, {numFiles: this.files.length}
      )
    },
    getUploadProblemMessage() {
      return this.$gettextInterpolate(
        this.$pgettext('globalUploader.errors', '%{numFiles} files failed to upload'),
        {numFiles: this.uploadProblem.length}
      )
    }
  }
}
</script>